export const initialState = {
    loading:false,
    vehicleModels:[],
    searchResult:[],
    searchLoading: false
};
